import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";

export const LegalLayout = ({ title, lastUpdated, children, testId }) => {
  return (
    <div className="min-h-screen bg-background">
      <header className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="legal-home-link">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-[hsl(var(--brimi-blue))] to-[hsl(var(--brimi-coral))] flex items-center justify-center shadow-sm">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <div className="font-black text-xl tracking-tight">Brimi AI</div>
        </Link>
        <Link
          to="/"
          data-testid="legal-back-home"
          className="pill-btn bg-foreground/5 text-foreground text-sm hover:bg-foreground/10 inline-flex items-center gap-1.5"
        >
          <ArrowLeft className="w-4 h-4" />
          Home
        </Link>
      </header>

      <main
        data-testid={testId}
        className="max-w-3xl mx-auto px-6 pt-8 pb-20"
      >
        <div className="mb-8">
          <h1 className="text-4xl sm:text-5xl font-black tracking-tight">{title}</h1>
          {lastUpdated && (
            <p className="text-sm text-muted-foreground mt-3">
              Last updated: <span className="font-semibold">{lastUpdated}</span>
            </p>
          )}
        </div>

        <div className="prose prose-neutral max-w-none text-[15px] leading-relaxed space-y-5 [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:mt-10 [&_h2]:mb-3 [&_h3]:text-lg [&_h3]:font-bold [&_h3]:mt-6 [&_h3]:mb-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_a]:text-[hsl(var(--brimi-blue))] [&_a]:underline [&_strong]:font-semibold">
          {children}
        </div>
      </main>

      <LegalFooter />
    </div>
  );
};

export const LegalFooter = () => {
  return (
    <footer className="border-t border-border bg-muted/30">
      <div className="max-w-5xl mx-auto px-6 py-8 flex flex-col md:flex-row md:items-center justify-between gap-4 text-sm text-muted-foreground">
        <div className="font-semibold">© {new Date().getFullYear()} Brimi AI. All rights reserved.</div>
        <nav className="flex flex-wrap gap-x-5 gap-y-2">
          <Link to="/about" data-testid="footer-about-link" className="hover:text-foreground">About</Link>
          <Link to="/contact" data-testid="footer-contact-link" className="hover:text-foreground">Contact</Link>
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-foreground">Privacy</Link>
          <Link to="/terms" data-testid="footer-terms-link" className="hover:text-foreground">Terms</Link>
          <Link to="/refund" data-testid="footer-refund-link" className="hover:text-foreground">Refund Policy</Link>
        </nav>
      </div>
    </footer>
  );
};
